// Санитизация готового HTML документов школы перед рендером через
// dangerouslySetInnerHTML. Парсим в изолированный документ (скрипты и ресурсы
// при этом не выполняются) и оставляем только безопасную типографику.
const ALLOWED_TAGS = new Set([
  "p",
  "br",
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "ul",
  "ol",
  "li",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "a",
  "span",
  "hr",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
]);

const ALLOWED_ATTR = new Set(["href", "target", "rel"]);

const sanitizeHtml = (dirty: string): string => {
  if (!dirty) return "";

  try {
    const doc = new DOMParser().parseFromString(dirty, "text/html");

    Array.from(doc.body.querySelectorAll("*")).forEach((el) => {
      if (!ALLOWED_TAGS.has(el.tagName.toLowerCase())) {
        el.remove();
        return;
      }

      Array.from(el.attributes).forEach((attr) => {
        const name = attr.name.toLowerCase();
        const isJsHref =
          name === "href" && /^\s*javascript:/i.test(attr.value);
        if (!ALLOWED_ATTR.has(name) || isJsHref) {
          el.removeAttribute(attr.name);
        }
      });

      // Внешние ссылки открываем безопасно
      if (el.tagName.toLowerCase() === "a" && el.getAttribute("target") === "_blank") {
        el.setAttribute("rel", "noopener noreferrer");
      }
    });

    return doc.body.innerHTML;
  } catch (e) {
    console.log(e);
    return "";
  }
};

export default sanitizeHtml;
